<template>
  <div class="menu__list">
    <div class="title" @click="handleTitle(item)">
      <div class="menu__item">
        {{ item.title }}
      </div>
      <img
        v-if="item.children"
        :class="{ rotate: isOpen }"
        src="@/assets/img/arrow-down.png"
      />
    </div>
    <div class="sublist" v-if="isOpen">
      <div v-for="(sublist, idx) in item.children" :key="idx">
        <router-link
          :to="sublist.path"
          v-if="
            sublist.userType === 'all' ? true : sublist.userType === userType
          "
          >{{ sublist.name }}</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item", "userType"],
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    handleTitle(menu) {
      if (!menu.children) {
        //하위 subMenu가 없는 Title은 토글 open이 아닌 페이지 이동
        if (this.$route.path !== menu.path) {
          this.$router.push(menu.path);
        }
      } else {
        this.isOpen = !this.isOpen;
      }
    }
  }
};
</script>
<style scoped>
.menu__list {
  margin-bottom: 40px;
}
.title {
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
}

.title img {
  width: 24px;
  height: 24px;
}

.title img.rotate {
  transform: rotate(-180deg);
}
.menu__item {
  font-size: 28px;
  font-weight: 500;
  line-height: 40px;
  color: var(--gray-700);
}

.sublist {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: var(--gray-700);
  gap: 16px;
  margin-top: 20px;
}
</style>
